import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {Subscription} from 'rxjs/Subscription';
import {LoginService} from '../../shared/_services/login.service';
import {ImageState} from '../../shared/_data-model/image';
import {environment} from '../../../environments/environment';
import {HcaUserManagementService} from '../../shared/_services/hca-user-management.service';
import {UtilService} from '../../shared/_services/util.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {
  hotelChainId: any;
  hotelBrands: any[] = [];
  email: any;
  user: any;
  role: any;
  menu: any[];
  imageSrc: any = '/assets/images/beach_stock.jpg';
  activeSubMenu: string | null = null;

  private subscription: Subscription;
  minHeight: any = window.innerHeight > 980 ? window.innerHeight : 980;

  constructor(
    public router: Router,
    private loginService: LoginService,
    public translate: TranslateService,
    private hcaUserManagementService: HcaUserManagementService,
    private utilService: UtilService,
  ) {
    this.email = JSON.parse(localStorage.getItem('loggedInUser')).email;
  }


  toggleSubMenu(menuName: string) {
    this.activeSubMenu = this.activeSubMenu === menuName ? null : menuName;
  }

  closeSubMenu() {
    this.activeSubMenu = null;
  }

  /* Function to logout from application */
  logout() {
    this.loginService.logout().subscribe(
      data => {
        localStorage.clear();
        this.router.navigate(['/login']).then();
        console.log('logout success');
      }, error => {
        console.error('Logout failed : ' + error);
      });
  }

  getReqData() {
    if (this.hotelChainId) {
      this.hcaUserManagementService.getHotelBrandsByHotelChain().subscribe(
        res => {
          if (res.error === 0) {
            this.hotelBrands = res.responseObj;
          } else {
            console.error('Get Hotel Brands : ' + res.message);
          }
        }, err => {
          console.error(err);
        });
    } else {
      return false;
    }
  }


  ngOnInit() {
    this.user = JSON.parse(localStorage.getItem('loggedInUser'));
    this.role = this.utilService.parseJwt(this.user.token).info.roles;
    this.subscription = this.loginService.imageState
      .subscribe((state: ImageState) => {
        this.imageSrc = state.imageSrc;
      });
    this.imageSrc = this.user.profilePic ? `${environment.BASE_IMAGE_API}/images/profile_pics/${JSON.parse(
      localStorage.getItem('loggedInUser')).userId}/${this.user.profilePic}` : `/assets/images/profile-default.svg`;
    this.menu = this.user && this.user.userRoleId !== 11 ? this.hcaAdmin() : this.lsaAdmin();
    this.hotelChainId = JSON.parse(localStorage.getItem('loggedInUser')).hotelChainId;
    if (this.hotelChainId) {
      this.getReqData();
    }
  }

  errorLoading() {
    this.imageSrc = '/assets/images/profile-default.svg';
  }

  lsaAdmin() {
    return [
      {name: 'Hotel Chains', imageSrc: './assets/images/hotel.svg', navigate: '/hca-management', role: [], subMenu: []},
      {name: 'User Management', imageSrc: './assets/images/users.svg', navigate: '/user-management', role: [], subMenu: []},
      {name: 'Members', imageSrc: './assets/images/members.svg', navigate: '/members', role: [], subMenu: []}
    ];
  }

  hcaAdmin() {
    return [
      {
        name: 'Hotels', imageSrc: './assets/images/hotel.svg', navigate: '/hotel-management', role: ['ROLE_MKT', 'ROLE_CCS'], subMenu: []
      },
      {
        name: 'Marketing',
        imageSrc: './assets/images/prize.svg',
        navigate: '/marketing/rewards-catalog',
        role: ['ROLE_CCS', 'ROLE_MKT'],
        subMenu: [
          {
            name: 'Rewards', imageSrc: './assets/images/shopping-bag.svg',
            navigateTo: '/marketing/rewards-catalog', activeSrc: './assets/images/shopping-bag-active.svg',
            role: ['ROLE_CCS', 'ROLE_MKT']
          },
          {
            name: 'Promotions', imageSrc: './assets/images/ticket.svg',
            navigateTo: '/marketing/promotions', activeSrc: './assets/images/ticket-active.svg',
            role: ['ROLE_CCS', 'ROLE_MKT']
          }
        ]
      },
      {
        name: 'Employee', imageSrc: './assets/images/employees.svg', navigate: '/employees/exchange-benefits', role: ['ROLE_RH'], subMenu: [
          // {
          //   name: 'Benefits', imageSrc: './assets/images/shopping-bag.svg',
          //   navigateTo: '/employees/benefits', activeSrc: './assets/images/shopping-bag-active.svg'
          // },
          {
            name: 'Exchange Benefits', imageSrc: './assets/images/exchange_benifits.svg',
            navigateTo: '/employees/exchange-benefits', activeSrc: './assets/images/exchange_benifits-active.svg',
            role: ['ROLE_RH']
          },
          {
            name: 'Employees', imageSrc: './assets/images/member.svg',
            navigateTo: '/employees/employee-list', activeSrc: './assets/images/member-active.svg',
            role: ['ROLE_RH']
          }
        ]
      },
      { name: 'Members', imageSrc: './assets/images/members.svg', navigate: '/members', role: ['ROLE_CC', 'ROLE_CCS', 'ROLE_HCA'], subMenu: [] },
      { name: 'Concierge', imageSrc: './assets/images/members.svg', navigate: '/concierge', role: ['ROLE_CC', 'ROLE_CCS', 'ROLE_CGE', 'ROLE_CGS'], subMenu: [{
        name: 'Pending Items', imageSrc: './assets/images/calendar_white.svg',
        navigateTo: '/concierge', activeSrc: './assets/images/calendar_white.svg',
        role: []
      },
      {
        name: 'Search Member', imageSrc: './assets/images/members.svg',
        navigateTo: '/concierge-members-search', activeSrc: './assets/images/members.svg',
        role: ['ROLE_CC', 'ROLE_CCS', 'ROLE_CGE', 'ROLE_CGS']
      },] },
      { name: 'Smart Agents', imageSrc: './assets/images/members.svg', navigate: '/smartAgents', role: ['ROLE_CC', 'ROLE_CCS', 'ROLE_SA'], subMenu: [] },
      { name: 'Reception', imageSrc: './assets/images/members.svg', navigate: '/reception', role: ['ROLE_CC', 'ROLE_CCS', 'ROLE_RCT'], subMenu: [] },
      { name: 'Physical Cards', imageSrc: './assets/images/physical-card.svg', navigate: '/physical-cards', role: ['ROLE_CC', 'ROLE_CCS'], subMenu: [] },
      { name: 'Bookings', imageSrc: './assets/images/book.svg', navigate: '/bookings', role: ['ROLE_CC', 'ROLE_CCS', 'ROLE_CGE', 'ROLE_SA', 'ROLE_CGS'], subMenu: [] },
      { name: 'Reports', imageSrc: './assets/images/calendar_white.svg', navigate: '/reports', role: ['ROLE_CCS'], subMenu: [
        {
          name: 'Traceability Reports', imageSrc: './assets/images/calendar_white.svg',
          navigateTo: '/reports', activeSrc: './assets/images/globe-active.svg',
          role: []
        },
        {
          name: 'Audit Dashboard', imageSrc: './assets/images/exchange_benifits.svg',
          navigateTo: '/audit-dashboard', activeSrc: './assets/images/exchange_benifits-active.svg',
          role: ['ROLE_CCS']
        },
      ] },
      {
        name: 'Settings', imageSrc: './assets/images/settings-active.svg', navigate: '/settings/hca-general', role: ['ROLE_MKT'],
        subMenu: [
          {
            name: 'General', imageSrc: './assets/images/globe.svg',
            navigateTo: '/settings/hca-general', activeSrc: './assets/images/globe-active.svg',
            role: []
          },
          {
            name: 'Brand', imageSrc: './assets/images/brand.svg',
            navigateTo: '/settings/hca-brand', activeSrc: './assets/images/brand-active.svg',
            role: []
          },
          {
            name: 'Loyalty Program', imageSrc: './assets/images/loyalty.svg',
            navigateTo: '/settings/hca-loyalty-programs', activeSrc: './assets/images/loyalty-active.svg',
            role: []
          },
          {
            name: 'Loyalty Website', imageSrc: './assets/images/www.svg',
            navigateTo: '/settings/hca-loyalty-website', activeSrc: './assets/images/www-active.svg',
            role: ['ROLE_MKT']
          },
          {
            name: 'User Management', imageSrc: './assets/images/member.svg',
            navigateTo: '/settings/hca-user-management', activeSrc: './assets/images/member-active.svg',
            role: []
          },
          {
            name: 'History Changes', imageSrc: './assets/images/globe.svg',
            navigateTo: '/settings/hca-history-changes', activeSrc: './assets/images/globe-active.svg',
            role: []
          }
        ]
      },
      {name: 'Help', imageSrc: './assets/images/help.svg', navigate: '/help', role: [], subMenu: []},
    ];
  }
}



// WEBPACK FOOTER //
// ./src/app/components/navbar/navbar.component.ts